var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      attrs: {
        value: _vm.value,
        filterable: "",
        clearable: "",
        remote: "",
        placeholder: "Search Contacts",
        "remote-method": _vm.search,
        loading: _vm.loading,
        popperClass: "custom-popper",
        "value-key": "id",
      },
      on: { input: _vm.onInput },
    },
    _vm._l(_vm.options, function (item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: _vm.format(item), value: item },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }